export default __webpack_public_path__ + "static/media/english-to-korean-screenshot-02.98fa41bb.png";